<app-header *ngIf="appLoaded"></app-header>

<app-menu-sidebar
    *ngIf="appLoaded"
    class="bg-white position-fixed"
></app-menu-sidebar>

<div *ngIf="appLoaded" class="content-wrapper">
    <router-outlet></router-outlet>
</div>

<app-footer *ngIf="appLoaded"></app-footer>
<app-control-sidebar *ngIf="appLoaded"></app-control-sidebar>
<div
    id="sidebar-overlay"
    *ngIf="appLoaded"
    (click)="onToggleMenuSidebar()"
></div>
<app-loading *ngIf="!appLoaded"></app-loading>
